class Storage {
  async checkToken() {
    let pass = false;
    pass = localStorage.getItem("ltoken") == null ? false : true;
    return pass;
  }

  setlToken(ltoken: string) {
    localStorage.setItem("ltoken", ltoken);
  }
  getlToken() {
    return localStorage.getItem("ltoken");
  }

  setUToken(utoken: string) {
    localStorage.setItem("utoken", utoken);
  }
  getUToken() {
    return localStorage.getItem("utoken");
  }

  setLang(lang: any | undefined) {
    localStorage.setItem("lang", lang);
  }
  getLang() {
    return localStorage.getItem("lang");
  }

  setStyle(style: string) {
    localStorage.setItem("u-style", style);
  }
  getStyle() {
    return localStorage.getItem("u-style");
  }

  clearToken() {
    sessionStorage.clear();
    localStorage.clear();
  }
}
export default new Storage();
